
import { HttpClient } from '@angular/common/http';
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
@Component({
  selector: 'project-step-5',
  templateUrl: './step5-project.component.html',
  styleUrls: ['./../../create-project.component.scss']
})
export class ProjectStep5Component implements  OnInit  {
  listmatrix
  listgroup
  listpay
  idProject
  step:number = 0
  title="Datos"
  Step5form: FormGroup;
  private apiService: ApiServiceProject;
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService:ErrorService
  ) { 
   this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
  }

  ngOnInit(): void {
    this.spinner.show()
    this.Step5form = this.fb.group({
    matrix_id:[''],
    groups_id:[''],
    types_payment_id:[''],
    });
    this.apiService = new ApiServiceProject(this.http);


     this.apiService.getService(`list-project-datos-step-five`).subscribe({
      next: (data) => {
        if (data) {
          this.listmatrix = data.listMatrix;
          this.listgroup = data.listProjectGroups;
          this.listpay = data.listTypesPayment
          this.spinner.hide();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })

    
  }

 
 
  formSubmit(){
    this.spinner.show()
    let post = {
      projects_id: Number(this.idProject),
      matrix_id: Number(this.Step5form.value.matrix_id),
      groups_id: Number(this.Step5form.value.groups_id),
      types_payment_id: Number(this.Step5form.value.types_payment_id),
    }
    this.apiService.postService(`create-project-datos-step-five`,post).subscribe({
       next: (data) => {
         if (data.code == 1) {
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
           this.spinner.hide();
          } else {
           this.spinner.hide()
           Swal.fire({title: 'Se creo el proyecto con exito!',text: '',icon: 'success',heightAuto: false}).then(()=>{
            location.href= './pdg/project/list'
         })
           
         }
      },
     error: (error) => {
      this.errorService.error(error);
     }})
  }


}
